import script from "./LessonPlanEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonPlanEdit.vue?vue&type=script&setup=true&lang=js"

export default script